// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collection-list-item-name {
  cursor: pointer;
  display: inline-block;
  width: 65%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.collection-list-item-name:hover {
  text-decoration: underline;
}

.collection-list-item-icon {
  padding-right: 10px;
}

.collection-list-item {
  padding-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/AssetLibrary/CollectionListItem/CollectionListItem.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,oBAAA;AACJ","sourcesContent":[".collection-list-item-name {\n    cursor: pointer;\n    display: inline-block;\n    width: 65%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: middle;\n}\n\n.collection-list-item-name:hover {\n    text-decoration: underline;\n}\n\n.collection-list-item-icon {\n    padding-right: 10px;\n}\n\n.collection-list-item {\n    padding-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
